




















import {Vue, Component, Prop} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
@Component({
    components: {
    },
})
export default class NewPassword extends Mixins(UserRoleMixin, GlobalAlertMixin) {
    public validForm = false;
    public password = '';
    public userToReset: any = null;
    public loading = false;
    public passwordRules = [
        (v) => !!v || 'Password is required',
        (v) => v.length >= 5 || 'Password must be at least 5 characters',
    ];
    public mounted() {
        this.getUser();
    }
    public created() {
        this.getUser();
    }

    public async getUser() {
        const {User} = this.$FeathersVuex;
        const results = await User.find({query: {resetToken: this.$route.params.token}});
        if (results.total !== 0) {
            const [user] = results.data;
            this.userToReset = user;
        } else {
            this.$router.replace('/');
        }
    }
    public async tryChange() {
        try {
            this.userToReset.newPassword = this.password;
            this.userToReset.submittedToken = this.$route.params.token;
            console.log(this.userToReset);
            await this.userToReset.save();
            this.showAlert('Success! You may now login with your new password!', 'success');
            this.$router.replace('/');
        } catch (e) {
            this.showAlert(e.message, 'error');
        }
    }
    get canReset() {
        return this.userIsNull;
    }
}
